module.exports = __webpack_public_path__ + "img/195.3f6d5c94.jpg";